import { Link } from "react-router-dom"
import Image from 'react-bootstrap/Image';
import './dropdownmenu.scss'
import AwayterConnectIcon from './../../utils/resources/LogoAwC_Negatiu.png'
import { useSelector } from "react-redux";
import { selectUser } from '../../utils/redux/userSlice'
import { GetRouteLinks } from "../../utils/routeLinks";
import { menuLine } from "aw-sidebar";

const DropdownMenu = () => {
    const user = useSelector(selectUser)
    return (
        <div className='dropdown menuDropDown'>
            <div className='d-inline-flex align-items-center ' id="dropdownMenu" data-bs-toggle="dropdown" aria-expanded="false">
                <Image src={AwayterConnectIcon} width={48} className='img-fluid mt-1' />
            </div>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenu">
                {GetRouteLinks().map((r, i) => {
                    if (r.role && r.role.includes(user.role)) {
                        return (
                            <li key={i}>
                                {r.name === menuLine ? <hr className="dropdown-divider"></hr> :
                                    <Link
                                        to={r.route ? r.route : ''}
                                        className="dropdown-item mobileMenu"
                                    >
                                        <i className={r.icon}></i>
                                        <span className='ms-4'>{r.name}</span>
                                    </Link>}
                            </li>
                        )
                    }
                    return null
                })}
            </ul>
        </div>
    )

}

export default DropdownMenu